<div class="Dialog flex flex-col h-full">
  <mat-toolbar class="Dialog__header flex-none">
    <span>Meddelanden</span>
    <span class="flex-1"></span>
    <button mat-icon-button [routerLink]="messagesRoute" tabindex="-1" matTooltip="Gå till chatten">
      <mat-icon class="text-black">forum</mat-icon>
    </button>
  </mat-toolbar>
  <div mat-dialog-content class="Dialog__content !max-h-none">
    <app-messages-thread-list [isInDialog]="true" (onThreadClick)="openThreadInDialog($event)"></app-messages-thread-list>
  </div>
</div>
